import * as React from 'react'
import { colors } from '@components/shared'

export type PropsType = {
  size?: number,
  color?: string
}

const CheckIcon = (props: PropsType): React.ReactNode => {
  return (
    <svg width={props.size || 15} height={props.size || 15} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5118 4.84505L7.10413 12.9731C6.77904 13.2985 6.35232 13.4613 5.92586 13.4613C5.4994 13.4613 5.07267 13.2985 4.74732 12.9731L0.488236 8.71405C-0.162745 8.06334 -0.162745 7.00796 0.488236 6.35724C1.13869 5.70626 2.19486 5.70626 2.84505 6.35724L5.92586 9.43751L12.1549 2.48823C12.8054 1.83726 13.8613 1.83726 14.5118 2.48823C15.1627 3.13895 15.1627 4.19433 14.5118 4.84505Z"
        fill={props.color || colors.white}
      />
    </svg>
  )
}

export default CheckIcon
